import React from 'react';
import Avatar from 'react-avatar';
import { getAvatarColor } from '../util/avatarColor';

function UserIcon({ user, size = '42px', sx = {}, color, onClick = () => {} }) {
  const name = user.name ? user.name : `${user?.firstName || ''}  ${user?.lastName || ''}`;

  let _color = color;
  if (_color == null) {
    _color = getAvatarColor(name);
  }

  return <Avatar style={{ ...sx }} name={name} size={size} round textSizeRatio={1} color={_color} onClick={onClick} />;
}

export default UserIcon;
